import React from 'react'
import styles from './styles.css'
import useState from 'App/hooks/useState'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import range from 'lodash/range'
import moment from 'moment'
import Button from 'orionsoft-parts/lib/components/Button'
import cloneDeep from 'lodash/cloneDeep'

const daysOptions = range(30).map(index => {
  const date = moment()
    .startOf('day')
    .add(index, 'day')
  return {
    label: date.format('dddd DD-MM'),
    value: date.format()
  }
})

export default function Periods(props) {
  const [day, setDay] = useState()
  const [from, setFrom] = useState()
  const [to, setTo] = useState()
  const value = props.value || []

  const hoursOptions = range(24 * 2).map(index => {
    const date = moment(day)
      .startOf('day')
      .add(index * 30, 'minutes')
    return {
      label: date.format('HH:mm'),
      value: date.format()
    }
  })

  const add = () => {
    const newValue = cloneDeep(value)

    newValue.push({
      startDate: moment(from).toDate(),
      endDate: moment(to).toDate()
    })

    setDay()
    setFrom()
    setTo()

    props.onChange(newValue)
  }
  return (
    <div className={styles.container}>
      <div className="label">Periodos</div>
      {value.map((period, index) => {
        const start = moment(period.startDate)
        const end = moment(period.endDate)
        const onClick = () => {
          const newValue = cloneDeep(value)
          newValue.splice(index, 1)
          props.onChange(newValue)
        }
        return (
          <div key={index} onClick={onClick} className={styles.period}>
            El {start.format('dddd DD [de] MMMM')} de {start.format('HH:mm')} a{' '}
            {end.format('HH:mm')}
          </div>
        )
      })}
      <div className="row">
        <div className="col-xs-12 col-sm-3">
          <Select value={day} onChange={setDay} placeholder="Día" options={daysOptions} />
        </div>
        <div className="col-xs-12 col-sm-3">
          <Select value={from} onChange={setFrom} placeholder="Desde" options={hoursOptions} />
        </div>
        <div className="col-xs-12 col-sm-3">
          <Select value={to} onChange={setTo} placeholder="Hasta" options={hoursOptions} />
        </div>
        <div className="col-xs-12 col-sm-3" style={{textAlign: 'right'}}>
          <div style={{height: 10}} />
          <Button onClick={add}>Agregar</Button>
        </div>
      </div>
    </div>
  )
}
